// extracted by mini-css-extract-plugin
export default {"grid":"PunchupAttendanceByType_grid__ZpHX0"};